module.exports = __webpack_public_path__ + "media/common/img/ronell_stewart-6be675a5ffbfbcd6ef66158c1184718b.jpg";